class BrandsExclusive extends HTMLElement {
  connectedCallback() {
    const host = this.querySelector('swiper-component.brands-exclusive__swiper');
    if (!host || this.configure(host)) return;

    // The inner <swiper-component> can upgrade after this element (Shopify
    // re-rendering the section) or wait for the Swiper bundle, so apply the
    // overrides as soon as Swiper flags the host as initialized.
    this.observer = new MutationObserver(() => {
      if (this.configure(host)) this.stopObserving();
    });
    this.observer.observe(host, { attributes: true, attributeFilter: ['class'] });
  }

  disconnectedCallback() {
    this.stopObserving();
  }

  configure(host) {
    const swiper = host.swiper;
    if (!swiper) return false;

    swiper.params.simulateTouch = true;
    swiper.params.grabCursor = true;
    swiper.params.watchOverflow = false;
    swiper.allowTouchMove = host.dataset.disabledrag !== 'true';
    swiper.update();

    return true;
  }

  stopObserving() {
    if (!this.observer) return;

    this.observer.disconnect();
    this.observer = null;
  }
}

if (!customElements.get('brands-exclusive')) {
  customElements.define('brands-exclusive', BrandsExclusive);
}
